<script>
export default {
  data () {
    return {
      _timer: 0
    }
  },
  methods: {
    async customRecursive (func = () => false, time = 1000) {
      let recursive = async () => {
        if (await func()) {
          this._timer = setTimeout(recursive, time)
        }
      }
      await recursive()
    }
  },
  beforeDestroy () {
    clearTimeout(this._timer)
    this._timer = 0
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/customRecursive.vue